import Layout from "@/components/layout";
import { Badge } from "@/components/ui/badge";
import { Card, CardContent } from "@/components/ui/card";
import { Tabs, TabsContent } from "@/components/ui/tabs";
import { useUser } from "@/hooks/use-user";
import { fetchLinkedinCandidates } from "@/services/linkedin";
import { Box, CircularProgress, Button, Checkbox, FormControlLabel, colors } from "@mui/material";
import { debounce } from "lodash";
import { Briefcase, LinkedinIcon, MapPin } from "lucide-react";
import { useEffect, useState } from "react";
import { useLocation } from "wouter";



const LinkedInSearch = () => {
  const [filters, setFilters] = useState({
    location: "",
    skills: "",
    experience: "",
  });
  const { user, isLoading } = useUser();
  const [, setLocation] = useLocation();
  const [linkedInCandidates, setLinkedInCandidates] = useState([]);
  const [isChecked, setIsChecked] = useState(true); 

  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
  };

  const handleclick = () => {

    const filtersMap = new Map(Object.entries(filters));
    filtersMap.set('open_to_work', isChecked ? 'open to work' : '');
    fetchLinkedinCandidates(filtersMap).then(data => {
      setLinkedInCandidates(data);

    });
  };
  useEffect(() => {
    if (!isLoading && !user) {
      setLocation("/login");
    }
  }, [user, isLoading, setLocation]);

  const handleFilterChange = debounce((e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  }, 300);

  return (
    <Layout>
      <div className="space-y-8">
        <div>
          <h2 className="text-3xl font-bold tracking-tight">LinkedIn Search</h2>
          <p className="text-muted-foreground">
            Search and import candidates from linkedin
          </p>
        </div>
        <div className="space-y-4 p-4 border rounded bg-gray-100 ">
          <div className="flex flex-wrap gap-4">
            {["location", "skills","experience"].map((filter) => (
              <div className="flex flex-col" key={filter}>
          <label className="block text-sm font-medium">{filter}</label>
          <input
            type="text"
            name={filter}
            onChange={handleFilterChange}
            className="w-full p-2 border rounded"
          />
              </div>
            ))}
            <Box>
              <Button
          variant="contained"
          sx={{
            mt: 3,
            backgroundColor: 'black',
            color: 'white',
            '&:hover': {
              backgroundColor: '#333',
            },
          }}
          onClick={handleclick}
              >
          Search LinkedIn
              </Button>
            </Box>
          </div>
          <FormControlLabel
            control={
              <Checkbox
          defaultChecked
          sx={{
            color: 'black',
            '&.Mui-checked': {
              color: 'black',
            },
          }}
              />
            }
            label="open to work"
            onChange={handleCheckboxChange}
          />
        </div>
        {/* Candidate Cards */}
        <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
          {linkedInCandidates.map((candidate, index) => candidate && (
            <Card key={`${candidate.linkedInUrl}-${index}`} className="cursor-pointer">
              <CardContent className="pt-6">
                <div className="space-y-2">
                  <div className="flex items-center justify-between">
                    <h3 className="font-semibold">{candidate.name}</h3>
                    <Badge
                      variant={candidate.status === "new" ? "default" : "secondary"}
                    >
                      {candidate.status}
                    </Badge>
                  </div>
                  <div className="space-y-1 text-sm text-muted-foreground">
                    {candidate.location && (
                      <div className="flex items-center">
                        <MapPin className="mr-2 h-4 w-4" />
                        {candidate.location}
                      </div>
                    )}
                    {candidate.experience && (
                      <div className="flex items-center">
                        <Briefcase className="mr-2 h-4 w-4" />
                        {candidate.experience} years
                      </div>
                    )}
                    {candidate.linkedInUrl && (
                      <div className="flex items-center">
                        <LinkedinIcon className="mr-2 h-4 w-4" />
                        <a
                          href={candidate.linkedInUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="hover:underline"
                        >
                          LinkedIn Profile
                        </a>
                      </div>
                    )}
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </Layout>
  );
};

export default LinkedInSearch;
